export default {
  title: {
    en: 'The Perfect Gift',
  },
  subTitle: {
    en: 'No guess work, they choose the perfume or cologne they want',
  },
  info: {
    supply: {
      en: 'Generous supply of fragrance (120 sprays monthly)',
    },
    available: {
      en: '3-, 6-, and 12-month options available',
    },
    collection: {
      en: '450 perfumes and 100+ colognes in our collection',
    },
    price: {
      en: 'Starting at just $44',
    },
  },
}
